import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Which tools does oursignals connect to?',
  a: 'HubSpot, Salesforce, GA4, Google Ads, Meta Ads, LinkedIn Ads, TikTok Ads, Stripe, Segment, Mixpanel, Amplitude, Intercom, Snowflake, Slack and 40+ more — with new sources added every month.'
}, {
  q: 'How long does it take to set up?',
  a: 'Most teams connect their first sources in under an hour. Each integration is OAuth-based, so there are no pipelines to build and no engineering required.'
}, {
  q: 'Do I need a data warehouse or engineering team?',
  a: 'No. oursignals handles identity resolution, deduplication and field mapping for you. If you do run a warehouse, we can sync clean data into Snowflake on higher tiers.'
}, {
  q: 'How does attribution work?',
  a: 'We stitch every touch — ad clicks, site sessions, emails and sales activity — to a unified identity, then let you model attribution multi-touch, first-touch or last-touch.'
}, {
  q: 'Is my data secure?',
  a: 'Data is encrypted in transit and at rest. Scale plans include SSO, role-based access control, a signed DPA and a full security review.'
}, {
  q: 'What counts as a "signal"?',
  a: 'A signal is any meaningful event from a connected source — a conversion, a deal stage change, an ad spend update, a product event or an intent trigger.'
}, {
  q: 'Can I send signals to other tools?',
  a: 'Yes. Route any signal to Slack, email or a webhook, and sync unified audiences back into Meta, Google and HubSpot to activate what you learn.'
}, {
  q: 'Is there a free plan?',
  a: 'Yes — the Starter plan is free forever with up to 3 sources and 100k signals per month. No credit card required.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="py-20 md:py-28" data-id="element-25">
      <div className="mx-auto max-w-[900px] px-5 md:px-8" data-id="element-26">
        <h2 className="font-display text-4xl font-semibold leading-[1.05] tracking-tight md:text-6xl" data-id="element-27">
          Questions, answered.
        </h2>

        <div className="mt-12 border-t border-ink/15" data-id="element-28">
          {faqs.map((item, i) => {
          const isOpen = open === i;
          return <div key={item.q} className="border-b border-ink/15" data-id="element-29">
                <button onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-6 text-left" aria-expanded={isOpen} data-id="element-30">
                  <span className="text-lg font-semibold md:text-xl" data-id="element-31">
                    {item.q}
                  </span>
                  <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-ink text-cream" data-id="element-32">
                    {isOpen ? <MinusIcon className="h-4 w-4" data-id="element-33" /> : <PlusIcon className="h-4 w-4" data-id="element-34" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-35">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-36">
                      <p className="pb-6 pr-12 text-ink/60" data-id="element-37">{item.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}